/* ========================================================================
    Application main script
 ========================================================================== */
import { toggleRadioVisibility } from "~modules/visibility";
import { confirmDlete, confirmDleteLink } from "~modules/confirm-delete";
import {
    annualConferenceForm,
    annualConferenceInvitationForm,
    annualConferenceInvitationSpecialOffer,
    annualConferenceOpinionExchangeMeetingPrice,
} from "~modules/annual-conference-form";
import { formOrganization } from "~modules/form-organization";
import {
    switchBillingAddressPlaceholderOpinionExchangeMeeting,
    switchBillingAddressPlaceholder,
} from "~modules/switch-billing-address-placeholder";
import switchFormsByMemberType from "~modules/switch-forms-by-member-type";

// Visibility toggle.
window.addEventListener("DOMContentLoaded", toggleRadioVisibility);

// Confirm delete.
window.addEventListener("DOMContentLoaded", confirmDlete);
window.addEventListener("DOMContentLoaded", confirmDleteLink);

// 指定した会員種別のフォームを表示する（汎用）
window.addEventListener("DOMContentLoaded", switchFormsByMemberType);

// 指定した会員種別のフォームを表示する（アニュアルカンファレンス）
window.addEventListener("DOMContentLoaded", annualConferenceForm);
window.addEventListener("DOMContentLoaded", annualConferenceInvitationForm);

// 招待枠フォームの UNITT 役職で意見交換会の請求書宛名を切り替える
window.addEventListener(
    "DOMContentLoaded",
    annualConferenceInvitationSpecialOffer,
);

// 招待枠, スポンサー枠フォームの 有料・無料 判定で意見交換会の請求書宛名を切り替える.
window.addEventListener(
    "DOMContentLoaded",
    annualConferenceOpinionExchangeMeetingPrice,
);

// 組織・機関名が「個人賛助会員・非会員」の場合フォームを表示する
// window.addEventListener("DOMContentLoaded", formOrganization);

// 請求書の宛名区分で placeholder の値を切り替える
window.addEventListener(
    "DOMContentLoaded",
    switchBillingAddressPlaceholderOpinionExchangeMeeting,
);
window.addEventListener("DOMContentLoaded", switchBillingAddressPlaceholder);
